import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

export const fetchPostOpOrders = async (uhidNo) => {
  const response = await axios.get(`${API_BASE_URL}/get_post_operative_order/${uhidNo}`);
  return response.data;
};

export const savePostOpOrders = async (data) => {
  const response = await axios.post(`${API_BASE_URL}/post_operative_order`, data);
  return response.data;
};

export const updatePostOpOrders = async (uhidNo, data) => {
  const response = await axios.put(`${API_BASE_URL}/update_post_operative_order/${uhidNo}`, data);
  return response.data;
};

export const generateShareToken = async (uhidNo) => {
  const response = await axios.post(`${API_BASE_URL}/generate_for_post_op_orders_api_share_token/${uhidNo}`);
  return response.data;
};
